import { render } from "./Team_manager_adviser_en.vue?vue&type=template&id=595dc939&scoped=true"
import script from "./Team_manager_adviser_en.vue?vue&type=script&lang=js"
export * from "./Team_manager_adviser_en.vue?vue&type=script&lang=js"

import "./Team_manager_adviser_en.vue?vue&type=style&index=0&id=595dc939&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-595dc939"

export default script